import MyService from '../../service';

const AddonApi = {
  getFacilitationAddOn: async () => {
    try {
      const { data } = await MyService.getRequestData('/addons/facilitation');

      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  },
};

export default AddonApi;
